import script from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=367559b4&lang=css"

const __exports__ = script;

export default __exports__